import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./screens/App";
import "./styles.css";
import "./overrides.css";
import "./r3.css";
import "./r4.css";
import "./r5.css";
import "./r6.css";
import "./r7.css";
import "./r8.css";
import "./r9.css";
import "./r10.css";
import "./r11.css";
import "./r12.css";
import "./r13.css";
import "./r14.css";
import "./r15.css";
import "./r17.css";
import "./r18.css";
import "./r21.css";
import "./r30.css";
import "./r31.css";
import "./r32.css";

createRoot(document.getElementById("root")!).render(<StrictMode><App/></StrictMode>);
if("serviceWorker" in navigator&&import.meta.env.PROD)window.addEventListener("load",async()=>{
  const legacyScope=`${location.origin}/dominateanddelegate/`;
  const registrations=await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.filter(registration=>registration.scope===legacyScope).map(registration=>registration.unregister()));
  await navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`);
});
